import React, { useState } from 'react'
import { Option, Sorting } from '../../search-spring/types/types'
import DesktopSortingItem from './DesktopSortingItem'

type Props = {
  sorting: Sorting
}

const SortingFilter = ({sorting}: Props) => {
  const [activeSort, setActiveSort] = useState('')

  return (
    <div className="p-5 min-w-44 xl:min-w-52 2xl:min-w-60 text-end">
      <h2 className="font-bstSpyre uppercase text-sm mb-XS">sort by</h2>
      <div className="flex flex-col gap-y-2XS">
        {sorting.options.map((sortingOrder: Option, index: number) => (
          <DesktopSortingItem key={index} sortingOrder={sortingOrder} activeSort={activeSort} setActiveSort={setActiveSort} />
        ))}
      </div>
    </div>
  )
}

export default SortingFilter